import { Tab, TabsComponent } from '@components';
import { Box } from '@atgfr8/atg-ui-tailwind';
import { fetchCustomerDetailsDocuments } from '@mobileStore/customer';
import { useParams } from '@solidjs/router';
import { CustomerGeneralDocuments } from '@typeDefinitions/customerTypes';
import { createEffect, createSignal } from 'solid-js';
import SectionCard from '@mobileComponents/SectionCard';

import { CustomerDocumentUploader } from './CustomerDocumentUploader';

const Documents = () => {
  const [activeTab, setActiveTab] = createSignal(0);
  const [documents, setDocuments] = createSignal<CustomerGeneralDocuments[]>(
    [],
  );

  const params = useParams();

  createEffect(async () => {
    setDocuments([]);
    const res = await fetchCustomerDetailsDocuments(params.id as string);
    if (res && res.isSuccess) {
      setDocuments(res.value);
    }
  });

  const activeTabType = () => {
    switch (activeTab()) {
      case 0:
        return 'Public';
      case 1:
        return 'Confidential';
      case 2:
        return 'Misc';
      case 3:
        return 'Logo';
      default:
        return 'Public';
    }
  };
  return (
    <Box>
      <SectionCard title="DOCUMENTS">
        <Box>
          <TabsComponent
            onTabClick={(i) => {
              setActiveTab(i);
            }}
            activeTab={activeTab()}
            tabs={['Public', 'Confidential', 'Misc', 'Logo'].map((item) => (
              <Tab>{item}</Tab>
            ))}
          />
        </Box>
        <Box p={1}>
          <CustomerDocumentUploader
            documents={documents}
            type={activeTabType()}
          />
        </Box>
      </SectionCard>
    </Box>
  );
};

export default Documents;
